<template>
  <IQOS :hideTitle="true">
    <div class="chart-container"><CircleChart :value="total_progress"/></div>

    <div class="container-box">
      <div class="label">
        {{ $t('cafe_fill_profile.comment') }}
      </div>
      <div class="container-box">
        <div 
          :class="{
            'item': true,
            'item-active': v >= 100
          }"
          v-for="(v,k) in filling" 
          :key="k"
          @click="$router.push(routes[k])">
          <img
            :src="`/icons/check-list-icon-${v == 100 ? 'active' : 'disabled'}.svg`"
            alt=""
          />
          {{ $t('cafe_fill_profile.params.'+k) }}
        </div>
      </div>
    </div>
  </IQOS>
</template>
<script>
import IQOS from "../IQOS.old.vue";
import CircleChart from "./CircleChart.vue";
import StatsAPI from "@/api/stats"

export default {
  components: { IQOS, CircleChart },
  data() {
    return {
      filling: {

      },
      routes: {
        contacts: 'general',
        descriptions: 'menus',
        online_payment: 'online_payment',
        photos: 'menus',
        translations: 'menus'
      },
      total_progress: 0
    }
  },
  mounted() {
    StatsAPI.getProfileFilling(this.$store.state.cafe._id).then(data => {
      this.filling = data.filling.params;
      this.total_progress = data.filling.total;
    }).catch(err => {

    });
  }
};
</script>
<style scoped>
.label {
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  color: #908f8d;
}

.item {
  font-size: 2.2222222222222223vh;
  line-height: 2.5555555555555554vh;
  color: #908f8d;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 1.6666666666666667vh;
}

.item-active {
  color: #ededed;
}

.item:last-child {
  margin-bottom: 0;
}
.item img {
  width: 2.6666666666666665vh;
  height: 2.6666666666666665vh;
  margin-right: 1.1111111111111112vh;
}
.chart-container {
  width: 100%;
}
</style>
